// extracted by mini-css-extract-plugin
export default {"list":"ModalList_list__0jvzj","listItem":"ModalList_listItem__sflhy"};